import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "h-full w-full text-center" }
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "w-1/4" }, null, -1)
const _hoisted_4 = { class: "w-3/4" }
const _hoisted_5 = { class: "grid h-10 grid-cols-12" }
const _hoisted_6 = { class: "my-4" }
const _hoisted_7 = { class: "flex mb-2" }
const _hoisted_8 = { class: "w-1/4 text-right" }
const _hoisted_9 = { class: "w-3/4" }
const _hoisted_10 = { class: "grid h-10 grid-cols-12" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Scale = _resolveComponent("Scale")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Graph = _resolveComponent("Graph")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scales, (s, k) => {
            return (_openBlock(), _createBlock(_component_Scale, { key: k }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(s), 1)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ])
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.years, (year, k2) => {
      return (_openBlock(), _createElementBlock("div", { key: k2 }, [
        _createElementVNode("div", _hoisted_6, _toDisplayString(year), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lensListPerYear[year], (lensData, k) => {
          return (_openBlock(), _createElementBlock("div", { key: k }, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", null, [
                  _createVNode(_component_router_link, {
                    to: _ctx.localizedUrl(lensData.lens.makerPath)
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(lensData.lens.maker) + " / " + _toDisplayString(lensData.lens.data.mount), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]),
                _createElementVNode("div", null, [
                  _createVNode(_component_router_link, {
                    to: _ctx.localizedUrl(lensData.lens.path)
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(lensData.lens.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scalesArray, (s, j) => {
                    return (_openBlock(), _createBlock(_component_Graph, {
                      key: j,
                      scales: s,
                      lensData: lensData.lens.data
                    }, null, 8, ["scales", "lensData"]))
                  }), 128)),
                  _hoisted_12
                ])
              ])
            ])
          ]))
        }), 128))
      ]))
    }), 128))
  ]))
}